/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWorkspaceRequest } from '../../models/create-workspace-request';
import { CreateWorkspaceResponse } from '../../models/create-workspace-response';

export interface CreateWorkspace$Params {
  
    /**
     * Workspace data
     */
    body: CreateWorkspaceRequest
}

export function createWorkspace(http: HttpClient, rootUrl: string, params: CreateWorkspace$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateWorkspaceResponse>> {
  const rb = new RequestBuilder(rootUrl, createWorkspace.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateWorkspaceResponse>;
    })
  );
}

createWorkspace.PATH = '/workspaces';
